import * as asyncUtils from 'ui-permit/shared-components/utils/async';
import * as ACTIONS from '../constants/actions';

const getLottery = asyncUtils.makeAsyncReducer(ACTIONS.GET_INVENTORY_CONTENT);

export const inventoryContent = asyncUtils.mergeReducers(
    asyncUtils.asyncDefaults({}),
    ACTIONS.PREFIX,
    getLottery
);

export const selectors = {
    getContent(state) {
        return state.queuingLottery?.inventoryContent?.data ?? {};
    },
    getNeedToKnowOrder(state) {
        return this.getContent(state)?.description?.need_to_know_order ?? '';
    },
};
